module.exports = __webpack_public_path__ + "media/newstyle/images/icon-questionmark-red-010ab972a7c8d3d8f308c999cd277072.svg";